import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";
import { PromoItem, Title } from "@/ui";

export default function PromoSection({ sectionId, className, bgColor, title, titleColor, items, md = 3 }) {
  if (items.length === 0) return null;

  return (
    <div id={sectionId} className={clsx(className, bgColor, classes.section)}>
      <Container className="mw-xxl">
        <Title className={titleColor} title={title} />
        <Row>
          {items.map(({ title, description, img, featured, href, button, external }, k) => (
            <Col key={k} xs={12} md={md} className="mb-4 mb-md-5">
              <PromoItem
                className="h-100"
                title={title}
                description={description}
                img={img?.url}
                href={href}
                cta={button}
                featured={featured}
                external={href.startsWith("http")}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
